import { SERVICE } from '../constants';
import { TYPE_COLLECTION } from './input-types';

export const id = SERVICE;
export const apiKey = 'ServiceId';
export const type = TYPE_COLLECTION;

export const service = {
  id,
  apiKey,
  type,
};
